import styled from "styled-components/macro";
import {DefaultFont} from "../../styles/fonts";

export const BlogCardDiv = styled.div`
  padding: 1em;
  cursor: pointer;
  border-radius: 8px;
  transition: background-color 0.2s;
  min-width: 15em;
  
  :hover {
    background-color: ${(props) => props.theme.colors.bgSecondary};
  }
  
  img {
    width: 100%;
    border-radius: 8px;
    aspect-ratio: 4 / 3;
    object-fit: cover;
    margin-bottom: 1em;
  }
  
  p {
    ${DefaultFont};
    color: ${(props) => props.theme.text.color.blueDimmed};
  }
  
  h2 {
    ${DefaultFont};
    font-weight: 500;
    @media ${(props) => props.theme.media.phone} {
      font-weight: 500;
    }
  }
`;
